import React from 'react';

import useLoadByScroll, {TOptions} from '@edna/hooks/useLoadByScroll';

const LoadByScroll = React.memo<TOptions>((options) => {
  useLoadByScroll(options);

  return null;
});

export default LoadByScroll;
